import {combineReducers} from 'redux';
import ACTION from '../action_constant';

function cards(state,action){
  switch (action.type) {
    case ACTION.PAYMENT.ADD_CARD:
      return [...state, action.card];
    case ACTION.PAYMENT.UPDATE_DEFAULT_CARD:
      let cardsState = Object.assign({} , state)
      for(let i = 0; i< cardsState; i++)
      {
          if(cardsState[i].cardId == action.paramObj.cardId)
          {
            cardsState[i].isDefault = true
          }else{
            cardsState[i].isDefault = false;
          }
      }
      return cardsState;
    case ACTION.PAYMENT.DELETE_CARD:
      state.splice(action.cardIndx,1);
      return state.concat([]);
    default:
      return state;
  }
}

function payment(state = {
  cards : [],
  histroy : []
}, action) {

  switch (action.type) {
    case ACTION.PAYMENT.ADD_DETAILS:
      return Object.assign({}, state, {
        cards : action.data.cards
      });
    case ACTION.PAYMENT.ADD_CARD:
      return Object.assign({}, state, {
        cards : cards(state.cards,action)
      });
    case ACTION.PAYMENT.DELETE_CARD:
    return Object.assign({}, state, {
        cards : cards(state.cards,action)
      });
    case ACTION.PAYMENT.UPDATE_DEFAULT_CARD:
    let cardsState = Object.assign({} , state)

    for(let i = 0; i< cardsState.cards.length; i++)
    {
        if(cardsState.cards[i].cardTokenId == action.paramObj.cardId)
        {
          cardsState.cards[i].isDefault = true
        }else{
          cardsState.cards[i].isDefault = false;
        }
    }
    return cardsState;
    default:
      return state;
  }
}

module.exports = payment;



// WEBPACK FOOTER //
// app/payment/payment_reducer.jsx